export const LOADED_EVENT = 'authentication-flow.loaded';
export const AUTHENTICATED_EVENT = 'authentication-flow.authenticated';
export const ERROR_EVENT = 'authentication-flow.error';
export const USER_BANNED_EVENT = 'authentication-flow.user-banned';
export const MISSING_REFRESH_TOKEN_EVENT = 'authentication-flow.missing-refresh-token';
export const SESSION_TIMEOUT_EVENT = 'authentication-flow.session-timeout';
